/**
 * Retrieves B2C service Page data for displaying on a page.
 * @param {Function} t - The translation function used to translate text strings.
 * @returns {Object} An object containing B2C service Page data.
 */

export const getB2CData = (id, t) => {
  const data = {
    'End-to-End-E-commerce-Logistics': {
      overview: {
        source: 'End-to-End-E-commerce-Logistics',
        heroHeader: 'Same-Day Delivery for ',
        heroHeader2: '',
        heroSubHeader: 'E-Commerce Businesses',
        heroPara:
          'Deliver orders within 24 hours and reduce RTOs with our reliable express shipping.',
        image: '/images/services/OverviewImg.webp',
        title: t('app.OVERVIEW'),
        alt: 'B2C logistics services',
        paragraph: [t('app.OVERVIEW_PARAGRAPH_1')],
      },
      xbFacilityDetails: {
        heading1: 'Why Choose This Service?',
        heading2: '',
        headerStyle: {
          position: 'center',
          heading1Color: '#f58220',
          heading2Color: '#000000',
          isBackgroundColor: false,
        },
        cardData: [
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-1.svg',
            title: 'Ultra-fast delivery',
            details: '',
            color: '#FFFFFF',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: '#FFFFFF',
            icon: '/images/services/FacilitySectionImg-2.svg',
            title: 'Nationwide reach covering 19,000+ pincodes',
            details: '',
            color: '#000000',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: '#ffffff',
            icon: '/images/services/FacilitySectionImg-3.svg',
            title: 'Reverse logistics and return management',
            details: '',
            color: '#000000',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Real-time tracking for customers and sellers',
            details: '',
            color: '#ffffff',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Dedicated account support and escalation matrix',
            details: '',
            color: '#ffffff',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Multiple payment options including Cash on Delivery',
            details: '',
            color: '#ffffff',
            cardStyles: {
              titleSize: '24px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
        ],
        globalCardsStyle: {
          alignItems: 'flex-end',
        },
      },
      weAreXpressBeesDetails: {
        headerData: {
          header: 'Why Choose This Service?',
          subHeader: '',
        },
        content: [
          {
            icon: '/images/services/ShipmentsDayIcon.webp',
            heading: '2M+',
            subHeading: 'Shipment/Day',
          },
          {
            icon: '/images/services/PinCodeIcon.webp',
            heading: '19,000+',
            subHeading: 'Pin Code',
          },
          {
            icon: '/images/services/CitiesDayDeliveryIcon.webp',
            heading: '50+',
            subHeading: 'Cities Same Day Delivery',
          },
          {
            icon: '/images/services/PincodeNextDayIcon.webp',
            heading: '8,500',
            subHeading: 'Pincode Next Day Delivery',
          },
          {
            icon: '/images/services/FulfillmentCenterIcon.webp',
            heading: '4,500+',
            subHeading: 'Fulfillment Centers',
          },
          {
            icon: '/images/services/LastMileDeliveryIcon.webp',
            heading: '30,000+',
            subHeading: 'Last Mile Delivery Partner',
          },
        ],
      },

      whyChooseUsDetails: {
        technology: {
          info: 'Technology',
          title1: 'Leading Platform with',
          title2: 'Most Advanced Solutions',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: 'Multimodal Shipping (Air/Surface Shipping)',
              details:
                'Choose the best mode of transportation-air or surface-to suit your business needs. Optimize cost and speed for every shipment.',
              img: '/images/services/whyChooseUs-1.webp',
            },
            {
              title: 'Customised Bulk Shipping  with PTL & FTL  Services',
              details:
                'Flexible Part-Truck Load (PTL) and Full-Truck Load (FTL) options to optimize bulk shipping, reducing costs and improving efficiency.',
              img: '/images/services/whyChooseUs-2.webp',
            },
            {
              title: 'Powered By Technology',
              details:
                '10+ automated high-end sorters for faster & more accurate package handling. Real-Time Tracking and efficient order management.',
              img: '/images/services/whyChooseUs-3.webp',
            },
          ],
          heroImage: '/images/heroImage_1.png',
          isStyle: false,
        },
      },
      whyChooseData: [
        {
          image: '/images/Xpress-Solutions-for-Super-Fast-Deliveries.png',
          heading: t('app.WHY_CHOOSE_HEADING_1'),
          detail: t('app.WHY_CHOOSE_DETAIL_1'),
        },
        {
          image: '/images/Cost-Effective-Pricing.png',
          heading: t('app.WHY_CHOOSE_HEADING_2'),
          detail: t('app.WHY_CHOOSE_DETAIL_2'),
        },
        {
          image: '/images/Value-Added-Services.png',
          heading: t('app.WHY_CHOOSE_HEADING_3'),
          detail: t('app.WHY_CHOOSE_DETAIL_3'),
        },
        {
          image: '/images/Industry-Expertise.png',
          heading: t('app.WHY_CHOOSE_HEADING_4'),
          detail: t('app.WHY_CHOOSE_DETAIL_4'),
        },
      ],
      xbForWarehousing: {
        headerData: {
          header: 'Why choose XpressBees for ',
          subHeader: '3PL & Warehousing',
        },
        content: [
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
        ],
      },
      keyBenefitsDetails: {
        headerData: {
          header: 'Key Features',
          subHeader: '',
        },
        content: [
          {
            img: '/images/services/KeyBenefitsImg-1.webp',
            icon: '/images/services/KeyBenefitsIcon-1.webp',
            title: 'Same-day or next-day delivery options',
          },
          {
            img: '/images/services/KeyBenefitsImg-2.webp',
            icon: '/images/services/KeyBenefitsIcon-2.webp',
            title: 'Cut-off time for each city or warehouse',
          },
          {
            img: '/images/services/KeyBenefitsImg-3.webp',
            icon: '/images/services/KeyBenefitsIcon-3.webp',
            title: 'Serviceable pin code checker',
          },
          {
            img: '/images/services/KeyBenefitsImg-4.webp',
            icon: '/images/services/KeyBenefitsIcon-4.webp',
            title: 'Smart routing and automated hub processing',
          },
          {
            img: '/images/services/KeyBenefitsImg-5.webp',
            icon: '/images/services/KeyBenefitsIcon-5.webp',
            title: 'Multi-item and customized packaging options',
          },
        ],
      },
      xpressBeesPlatformDetails: {
        technology: {
          info: 'Integration',
          title1: 'Seamless Integration',
          title2: 'with Leading Platforms',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: '',
              details:
                'XpressBees integrates effortlessly with major e-commerce platforms and marketplaces, making it easier for you to manage your logistics',
              img: '',
            },
            {
              title:
                'Woocommerce, Shopify, WareIQ, Shiprocket BigCommerce, Amazon, Flipkart, API Integrations',
              details: '',
              img: '',
            },
          ],
          heroImage: '/images/services/XpressBeesPlatformB2CImg.webp',
          isStyle: true,
        },
      },
      industriesData: {
        title: 'Who is This Service For?',
        industriesDetail: [
          {
            image: '/images/carousal/industries/b2c/Fashion-and-Apparel.jpg',
            heading: 'E-commerce companies with high order volume',
            detail: [
              t('app.B2C_INDUSTRIES_1_DETAIL_1'),

              t('app.B2C_INDUSTRIES_1_DETAIL_2'),

              t('app.B2C_INDUSTRIES_1_DETAIL_3'),

              t('app.B2C_INDUSTRIES_1_DETAIL_4'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Banking-and-Finance.jpg',
            heading: 'FMCG and pharmaceutical brands',
            detail: [
              t('app.B2C_INDUSTRIES_2_DETAIL_1'),

              t('app.B2C_INDUSTRIES_2_DETAIL_2'),

              t('app.B2C_INDUSTRIES_2_DETAIL_3'),
            ],
          },
          {
            image:
              '/images/carousal/industries/b2c/Consumer-Goods-and-FMCG.jpg',
            heading: 'Fashion and apparel businesses',
            detail: [
              t('app.B2C_INDUSTRIES_3_DETAIL_1'),
              t('app.B2C_INDUSTRIES_3_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Consumer-Electronics.jpg',
            heading: 'Bookstores and stationery distributors',
            detail: [
              t('app.B2C_INDUSTRIES_4_DETAIL_1'),

              t('app.B2C_INDUSTRIES_4_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Ecommerce.jpg',
            heading: 'Quick commerce and hyperlocal delivery startups',
            detail: [
              t('app.B2C_INDUSTRIES_5_DETAIL_1'),
              t('app.B2C_INDUSTRIES_5_DETAIL_2'),
              t('app.B2C_INDUSTRIES_5_DETAIL_3'),
            ],
          },
        ],
      },
      faqData: [
        {
          question: 'What is the turnaround time for this service?',
          answer: t('app.B2C_FAQ_ANSWER_1'),
        },
        {
          question: 'What is the coverage area for same-day delivery?',
          answer: t('app.B2C_FAQ_ANSWER_4'),
        },
        {
          question: 'How do I integrate your service with my e-commerce store?',
          answer: t('app.B2C_FAQ_ANSWER_5'),
        },
        {
          question: 'How is COD collected and settled?',
          answer: t('app.B2C_FAQ_ANSWER_6'),
        },
        {
          question: 'What happens in case of failed delivery?',
          answer: t('app.B2C_FAQ_ANSWER_7'),
        },
      ],
      clientCarousel: [
        {
          img: '/images/carousal/client/adidas.jpg',
        },
        {
          img: '/images/carousal/client/nykaa.jpg',
        },
        {
          img: '/images/carousal/client/flipkart.jpg',
        },
        {
          img: '/images/carousal/client/trends.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/first-cry.jpg',
        },
        {
          img: '/images/carousal/client/bucket.jpg',
        },
        {
          img: '/images/carousal/client/lic.webp',
        },
        {
          img: '/images/carousal/client/meesho.jpg',
        },
        {
          img: '/images/carousal/client/m-caffeine.jpg',
        },
        {
          img: '/images/carousal/client/purple.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/wow.jpg',
        },
        {
          img: '/images/carousal/client/cliq.jpg',
        },
        {
          img: '/images/carousal/client/zara.jpg',
        },
        {
          img: '/images/carousal/client/rbl.jpg',
        },
        {
          img: '/images/carousal/client/Souled-Store.jpg',
        },
        {
          img: '/images/carousal/client/icici.jpg',
        },
        {
          img: '/images/carousal/client/ajio.jpg',
        },
        {
          img: '/images/carousal/client/au.webp',
        },
      ],
      howItWorksConfig: {
        headerData: {
          header: 'How It Works',
        },
        desktop: '/images/services/HowItsWorkB2CDesktopImg.webp',
        tablet: '/images/services/HowItsWorkB2CTabletImg.webp',
        mobile: '/images/services/HowItsWorkB2CMobileImg.webp',
      },
    },
    'Reverse-Logistics': {
      overview: {
        source: 'Reverse-Logistics',
        heroHeader: 'Same-Day Delivery for ',
        heroHeader2: '',
        heroSubHeader: 'E-Commerce Businesses',
        heroPara:
          'Deliver orders within 24 hours and reduce RTOs with our reliable express shipping.',
        image: '/images/services/OverviewImg.webp',
        title: t('app.OVERVIEW'),
        alt: 'B2C logistics services',
        paragraph: [t('app.OVERVIEW_PARAGRAPH_1')],
      },
      weAreXpressBeesDetails: {
        headerData: {
          header: 'Why Choose This Service?',
          subHeader: '',
        },
        content: [
          {
            icon: '/images/services/ShipmentsDayIcon.webp',
            heading: '2M+',
            subHeading: 'Shipment/Day',
          },
          {
            icon: '/images/services/PinCodeIcon.webp',
            heading: '19,000+',
            subHeading: 'Pin Code',
          },
          {
            icon: '/images/services/CitiesDayDeliveryIcon.webp',
            heading: '50+',
            subHeading: 'Cities Same Day Delivery',
          },
          {
            icon: '/images/services/PincodeNextDayIcon.webp',
            heading: '8,500',
            subHeading: 'Pincode Next Day Delivery',
          },
          {
            icon: '/images/services/FulfillmentCenterIcon.webp',
            heading: '4,500+',
            subHeading: 'Fulfillment Centers',
          },
          {
            icon: '/images/services/LastMileDeliveryIcon.webp',
            heading: '30,000+',
            subHeading: 'Last Mile Delivery Partner',
          },
        ],
      },

      whyChooseUsDetails: {
        technology: {
          info: 'Technology',
          title1: 'Leading Platform with',
          title2: 'Most Advanced Solutions',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: 'Multimodal Shipping (Air/Surface Shipping)',
              details:
                'Choose the best mode of transportation-air or surface-to suit your business needs. Optimize cost and speed for every shipment.',
              img: '/images/services/whyChooseUs-1.webp',
            },
            {
              title: 'Customised Bulk Shipping  with PTL & FTL  Services',
              details:
                'Flexible Part-Truck Load (PTL) and Full-Truck Load (FTL) options to optimize bulk shipping, reducing costs and improving efficiency.',
              img: '/images/services/whyChooseUs-2.webp',
            },
            {
              title: 'Powered By Technology',
              details:
                '10+ automated high-end sorters for faster & more accurate package handling. Real-Time Tracking and efficient order management.',
              img: '/images/services/whyChooseUs-3.webp',
            },
          ],
          heroImage: '/images/heroImage_1.png',
          isStyle: false,
        },
      },
      whyChooseData: [
        {
          image: '/images/Xpress-Solutions-for-Super-Fast-Deliveries.png',
          heading: t('app.WHY_CHOOSE_HEADING_1'),
          detail: t('app.WHY_CHOOSE_DETAIL_1'),
        },
        {
          image: '/images/Cost-Effective-Pricing.png',
          heading: t('app.WHY_CHOOSE_HEADING_2'),
          detail: t('app.WHY_CHOOSE_DETAIL_2'),
        },
        {
          image: '/images/Value-Added-Services.png',
          heading: t('app.WHY_CHOOSE_HEADING_3'),
          detail: t('app.WHY_CHOOSE_DETAIL_3'),
        },
        {
          image: '/images/Industry-Expertise.png',
          heading: t('app.WHY_CHOOSE_HEADING_4'),
          detail: t('app.WHY_CHOOSE_DETAIL_4'),
        },
      ],
      xbForWarehousing: {
        headerData: {
          header: 'Why choose XpressBees for ',
          subHeader: '3PL & Warehousing',
        },
        content: [
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
          {
            bg: 'https://placehold.co/370x165',
            icon: '/images/flight_takeoff.svg',
            title: 'Advanced Infrastructure',
            details:
              'Leverage our 1.5 million sq. ft. Grade A infrastructure across 40+ cities, built to seamlessly support your unique inventory and operational requirements.',
          },
        ],
      },
      keyBenefitsDetails: {
        headerData: {
          header: 'Key Features',
          subHeader: '',
        },
        content: [
          {
            img: '/images/services/KeyBenefitsImg-1.webp',
            icon: '/images/services/KeyBenefitsIcon-1.webp',
            title: 'Same-day or next-day delivery options',
          },
          {
            img: '/images/services/KeyBenefitsImg-2.webp',
            icon: '/images/services/KeyBenefitsIcon-2.webp',
            title: 'Cut-off time for each city or warehouse',
          },
          {
            img: '/images/services/KeyBenefitsImg-3.webp',
            icon: '/images/services/KeyBenefitsIcon-3.webp',
            title: 'Serviceable pin code checker',
          },
          {
            img: '/images/services/KeyBenefitsImg-4.webp',
            icon: '/images/services/KeyBenefitsIcon-4.webp',
            title: 'Smart routing and automated hub processing',
          },
          {
            img: '/images/services/KeyBenefitsImg-5.webp',
            icon: '/images/services/KeyBenefitsIcon-5.webp',
            title: 'Multi-item and customized packaging options',
          },
        ],
      },
      xpressBeesPlatformDetails: {
        technology: {
          info: 'Integration',
          title1: 'Seamless Integration',
          title2: 'with Leading Platforms',
          background: "url('/images/services/whyChooseUsBG.webp')",
          textColor: '#ffffff',
          content: [
            {
              title: '',
              details:
                'XpressBees integrates effortlessly with major e-commerce platforms and marketplaces, making it easier for you to manage your logistics',
              img: '',
            },
            {
              title:
                'Woocommerce, Shopify, WareIQ, Shiprocket BigCommerce, Amazon, Flipkart, API Integrations',
              details: '',
              img: '',
            },
          ],
          heroImage: '/images/services/XpressBeesPlatformB2CImg.webp',
          isStyle: true,
        },
      },
      industriesData: {
        title: 'Who is This Service For?',
        industriesDetail: [
          {
            image: '/images/carousal/industries/b2c/Fashion-and-Apparel.jpg',
            heading: 'E-commerce companies with high order volume',
            detail: [
              t('app.B2C_INDUSTRIES_1_DETAIL_1'),

              t('app.B2C_INDUSTRIES_1_DETAIL_2'),

              t('app.B2C_INDUSTRIES_1_DETAIL_3'),

              t('app.B2C_INDUSTRIES_1_DETAIL_4'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Banking-and-Finance.jpg',
            heading: 'FMCG and pharmaceutical brands',
            detail: [
              t('app.B2C_INDUSTRIES_2_DETAIL_1'),

              t('app.B2C_INDUSTRIES_2_DETAIL_2'),

              t('app.B2C_INDUSTRIES_2_DETAIL_3'),
            ],
          },
          {
            image:
              '/images/carousal/industries/b2c/Consumer-Goods-and-FMCG.jpg',
            heading: 'Fashion and apparel businesses',
            detail: [
              t('app.B2C_INDUSTRIES_3_DETAIL_1'),
              t('app.B2C_INDUSTRIES_3_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Consumer-Electronics.jpg',
            heading: 'Bookstores and stationery distributors',
            detail: [
              t('app.B2C_INDUSTRIES_4_DETAIL_1'),

              t('app.B2C_INDUSTRIES_4_DETAIL_2'),
            ],
          },
          {
            image: '/images/carousal/industries/b2c/Ecommerce.jpg',
            heading: 'Quick commerce and hyperlocal delivery startups',
            detail: [
              t('app.B2C_INDUSTRIES_5_DETAIL_1'),
              t('app.B2C_INDUSTRIES_5_DETAIL_2'),
              t('app.B2C_INDUSTRIES_5_DETAIL_3'),
            ],
          },
        ],
      },
      faqData: [
        {
          question: 'What is the turnaround time for this service?',
          answer: t('app.B2C_FAQ_ANSWER_1'),
        },
        {
          question: 'What is the coverage area for same-day delivery?',
          answer: t('app.B2C_FAQ_ANSWER_4'),
        },
        {
          question: 'How do I integrate your service with my e-commerce store?',
          answer: t('app.B2C_FAQ_ANSWER_5'),
        },
        {
          question: 'How is COD collected and settled?',
          answer: t('app.B2C_FAQ_ANSWER_6'),
        },
        {
          question: 'What happens in case of failed delivery?',
          answer: t('app.B2C_FAQ_ANSWER_7'),
        },
      ],
      clientCarousel: [
        {
          img: '/images/carousal/client/adidas.jpg',
        },
        {
          img: '/images/carousal/client/nykaa.jpg',
        },
        {
          img: '/images/carousal/client/flipkart.jpg',
        },
        {
          img: '/images/carousal/client/trends.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/first-cry.jpg',
        },
        {
          img: '/images/carousal/client/bucket.jpg',
        },
        {
          img: '/images/carousal/client/lic.webp',
        },
        {
          img: '/images/carousal/client/meesho.jpg',
        },
        {
          img: '/images/carousal/client/m-caffeine.jpg',
        },
        {
          img: '/images/carousal/client/purple.jpg',
        },
        {
          img: '/images/carousal/client/samsung.jpg',
        },
        {
          img: '/images/carousal/client/wow.jpg',
        },
        {
          img: '/images/carousal/client/cliq.jpg',
        },
        {
          img: '/images/carousal/client/zara.jpg',
        },
        {
          img: '/images/carousal/client/rbl.jpg',
        },
        {
          img: '/images/carousal/client/Souled-Store.jpg',
        },
        {
          img: '/images/carousal/client/icici.jpg',
        },
        {
          img: '/images/carousal/client/ajio.jpg',
        },
        {
          img: '/images/carousal/client/au.webp',
        },
      ],
      howItWorksConfig: {
        headerData: {
          header: 'How It Works',
        },
        desktop: '/images/services/HowItsWorkB2CDesktopImg.webp',
        tablet: '/images/services/HowItsWorkB2CTabletImg.webp',
        mobile: '/images/services/HowItsWorkB2CMobileImg.webp',
      },
      xbFacilityDetails: {
        heading1: 'Xpress COD',
        heading2: ': Fast & Secure',
        headerStyle: {
          position: 'center',
          heading1Color: '#f58220',
          heading2Color: '#000000',
          isBackgroundColor: false,
        },
        cardData: [
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-1.svg',
            title: 'Cost-Effective Pricing',
            details: 'Shipping starts at ₹25*',
            color: '#FFFFFF',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
          {
            background: '#FFFFFF',
            icon: '/images/services/FacilitySectionImg-2.svg',
            title: 'Wide Network',
            details: 'Reach of 19,000+ Pincodes with PAN India Network',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: '#ffffff',
            icon: '/images/services/FacilitySectionImg-3.svg',
            title: 'WhatsApp / SMS',
            details: 'Seamless Updates to end customers.',
            color: '#000000',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              height: '266px',
              isFacilitySection: true,
            },
          },
          {
            background: 'linear-gradient(180deg, #F07C00 0%, #FFA443 100%)',
            icon: '/images/services/FacilitySectionImg-4.svg',
            title: 'Dedicated Account Management',
            details:
              'Enjoy personalized service with a dedicated account manager',
            color: '#ffffff',
            cardStyles: {
              titleSize: '28px',
              detailsSize: '16px',
              fontWeight: '600',
              icon: '50px',
              isFacilitySection: true,
            },
          },
        ],
        globalCardsStyle: {
          alignItems: 'flex-end',
        },
      },
    },
  };
  return data[id] || null;
};

export const getIndividualB2CData = (id, t) => {
  const b2cData = getB2CData(id, t);
  if (!b2cData) {
    console.error(`B2C service data for id ${id} not found.`);
  }
  return b2cData;
};
